export default __webpack_public_path__ + "static/media/02.df04fb16.svg";